import React, { useMemo } from "react";
import "./Define.css";
import { useSelector } from "react-redux";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { Box } from "@mui/material";
import {
  biWeeklyDepTotalCols,
  noDepTotalCols,
  summaryTotalView,
  weeklyDepTotalCols,
} from "./TotalColumns";

function TotalValues() {
  const define = useSelector((state) => state.define);
  const { gridDataFiltered, selectedDepletion, selectedView } = define;

  function selectColumn() {
    if (selectedView === 2) {
      return summaryTotalView;
    }
    if (
      selectedDepletion === null ||
      selectedDepletion === undefined ||
      selectedDepletion.value === undefined
    ) {
      return noDepTotalCols;
    } else {
      if (selectedDepletion.key === "biweekly") {
        return biWeeklyDepTotalCols;
      }
      if (selectedDepletion.value === "No depletion") {
        return noDepTotalCols;
      }
      return weeklyDepTotalCols;
    }
  }

  // Calculate totals from gridDataFiltered
  const totals = useMemo(() => {
    let totalUnusedQuota = 0;
    let totalInitialQuota = 0;
    let totalSafetyMargin = 0;
    let totalAdjustment = 0;
    let totalQuota = 0;
    let totalSIT = 0;
    let totalWeekly1 = 0;
    let totalWeekly2 = 0;
    let totalWeekly3 = 0;
    let totalWeekly4 = 0;
    let totalWeekly5 = 0;

    if (gridDataFiltered && gridDataFiltered.length > 0) {
      gridDataFiltered.forEach((row) => {
        // UnusedQuota
        if (row.unusedQuota !== undefined && row.unusedQuota !== "") {
          totalUnusedQuota += parseFloat(row.unusedQuota) || 0;
        }

        // Adjustment
        if (row.adjustment !== undefined && row.adjustment !== "") {
          totalAdjustment += Math.round(parseFloat(row.adjustment) || 0);
        }

        // InitialQuota
        if (row.initialQuota !== undefined && row.initialQuota !== "") {
          totalInitialQuota += parseFloat(row.initialQuota) || 0;
        }

        // Quota
        if (row.quota !== undefined && row.quota !== "") {
          totalQuota += parseFloat(row.quota) || 0;
        }

        // SafetyMargin - directly sum from gridDataFiltered
        if (row.safetyMargin !== undefined && row.safetyMargin !== "" && row.safetyMargin !== "-") {
          const safetyMarginValue = parseFloat(row.safetyMargin) || 0;
          if (!isNaN(safetyMarginValue)) {
            totalSafetyMargin += safetyMarginValue;
          }
        }

        // Weekly1
        if (row.weekly1 !== undefined && row.weekly1 !== "") {
          totalWeekly1 += parseFloat(row.weekly1) || 0;
        }

        // Weekly2
        if (row.weekly2 !== undefined && row.weekly2 !== "") {
          totalWeekly2 += parseFloat(row.weekly2) || 0;
        }

        // Weekly3
        if (row.weekly3 !== undefined && row.weekly3 !== "") {
          totalWeekly3 += parseFloat(row.weekly3) || 0;
        }

        // Weekly4
        if (row.weekly4 !== undefined && row.weekly4 !== "") {
          totalWeekly4 += parseFloat(row.weekly4) || 0;
        }

        // Weekly5
        if (row.weekly5 !== undefined && row.weekly5 !== "") {
          totalWeekly5 += parseFloat(row.weekly5) || 0;
        }

        // SIT
        if (row.sit !== undefined && row.sit !== "") {
          totalSIT += parseFloat(row.sit) || 0;
        }
      });
    }

    return {
      id: "totals",
      unusedQuota: totalUnusedQuota,
      initialQuota: totalInitialQuota,
      safetyMargin: totalSafetyMargin,
      adjustment: totalAdjustment,
      quota: totalQuota,
      weekly1: totalWeekly1,
      weekly2: totalWeekly2,
      weekly3: totalWeekly3,
      weekly4: totalWeekly4,
      weekly5: totalWeekly5,
      sit: totalSIT,
    };
  }, [gridDataFiltered]);

  const rows = [totals];

  return (
    <Box sx={{ mt: 2, mb: 2 }}>
      <DataGridPro
        sx={{
          "& .MuiDataGrid-columnHeaderTitle": {
            whiteSpace: "normal",
            lineHeight: "normal",
          },
          "& .MuiDataGrid-columnHeaders": {
            maxHeight: "168px !important",
          },
          "& .MuiDataGrid-virtualScroller": {
            maxHeight: "unset !important",
          },
          "& .MuiDataGrid-row": {
            // backgroundColor: "#f5f5f5",
            fontWeight: "bold",
          },
        }}
        autoHeight={true}
        rowHeight={50}
        rows={rows}
        getRowId={(row) => row.id}
        columns={selectColumn()}
        disableRowSelectionOnClick={true}
        hideFooter={true}
        disableColumnMenu
        disableColumnFilter
        disableColumnSelector
        columnHeaderHeight={65}
      />
    </Box>
  );
}

export default TotalValues;

